import React from 'react';
import './AIDisclosureModal.css';

export default function AIDisclosureModal({ open, onAcknowledge }) {
  if (!open) return null;

  return (
    <div className="ai-disclosure-overlay">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="ai-disclosure-title"
        className="ai-disclosure-modal"
      >
        <h1 id="ai-disclosure-title" className="ai-disclosure-title">
          Information importante (AI Act art. 50)
        </h1>
        <div className="ai-disclosure-body">
          <p>
            La musique diffusée par Melodiza est générée intégralement par
            intelligence artificielle. Aucune œuvre n'est créée par un humain
            identifié. Conformément à l'article 50 du règlement européen
            2024/1689 sur l'intelligence artificielle (AI Act), nous vous
            informons explicitement de cette génération automatique.
          </p>
          <p>
            <strong>Conséquences :</strong>
          </p>
          <ul>
            <li>
              Aucune redevance SACEM/SPRE n'est due (catalogue 100% IA
              non-géré).
            </li>
            <li>
              Chaque morceau possède un manifest C2PA vérifiable attestant son
              origine IA.
            </li>
            <li>
              Vous pouvez consulter à tout moment le détail dans Paramètres &gt;
              Conformité.
            </li>
          </ul>
        </div>
        <button
          type="button"
          onClick={onAcknowledge}
          className="ai-disclosure-cta"
          autoFocus
        >
          J'ai compris et j'accepte
        </button>
      </div>
    </div>
  );
}
